import { Components, Theme } from "@mui/material";

export const muiPopperTheme = (
  theme: Theme,
): Pick<Components<Omit<Theme, "components">>, "MuiPopper"> => ({
  MuiPopper: {},
});
